<template>
  <!-- 添加标签对话框 -->
  <el-dialog
    :title="title"
    :visible.sync="isShowRoleDialog"
    :before-close="handleClose"
    :close-on-click-modal="false"
    width="480px"
    class="crm-add-tag-dialog"
  >
    <el-form ref="tagsForm" :model="tagsForm" label-width="80px" :rules="rules">
      <el-form-item label="标签名称" prop="name">
        <el-input v-model="tagsForm.name" placeholder="10个字以内"/>
      </el-form-item>
      <el-form-item label="选择颜色">
        <template v-for="color in colorList">
         <el-radio-group v-model="tagsForm.color" :key="color.name">
            <el-radio :label="color.name" :class="color.type"></el-radio>
          </el-radio-group>
        </template>
        <div class="mg_t_10">
         <el-color-picker v-model="tagsForm.color">
         </el-color-picker>
           <span class="crm-color-name">{{ tagsForm.color }}</span>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">取 消</el-button>
      <el-button type="primary" @click="handleConfirm" size="small">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
// import { addRole, editRole, getUsersByRoleId } from '@/api/role'
import { saveTag, updateTag } from '@/api/crm/clientTag'

export default {
  data() {
    const validLen = (rule, value, callback) => {
      // 标签名称不能超过10个汉字
      if (!value || (value.trim().length === 0)) {
        callback(new Error('请输入标签名称'))
      } else if (this.getByteLen(value.trim()) > 20) {
        callback(new Error('标签名称过长, 请控制在10个字以内'))
      } else {
        callback()
      }
    }
    return {
      tagsForm: { color: '#409EFF' },
      isShowRoleDialog: false,
      mould: '3004',
      rules: {
        name: [{ validator: validLen, trigger: ['blur', 'change'] }]
      },
      action: 'add',
      colorList: [{ name: '#2db7f5', type: 'blue' }, { name: '#67c23a', type: 'green' }, { name: '#f56c6c', type: 'pink' }, { name: '#ffa902', type: 'yellow' }, { name: '#00cccd', type: 'skyblue' }, { name: '#aace06', type: 'lime' }, { name: '#e03e74', type: 'hotpink' }]
    }
  },
  computed: {
    title() {
      return this.action === 'add' ? '添加标签' : '编辑标签'
    }
  },
  methods: {
    getByteLen(val) {
      var len = 0
      for (var i = 0; i < val.length; i++) {
        var a = val.charAt(i)
        // eslint-disable-next-line no-control-regex
        if (a.match(/[^\x00-\xff]/ig) != null) {
          len += 2
        } else {
          len += 1
        }
      }
      return len
    },
    handleConfirm() {
      this.$refs.tagsForm.validate((valid) => {
        const options = { ...this.tagsForm }
        if (valid) {
          options.name = options.name.trim()
          options.mould = this.mould
          if (options.id) {
          // 编辑标签
            updateTag(options).then(res => {
              if (res.code !== '2000') {
                this.$message.warning(res.meaning)
                return
              }
              // 关闭弹窗
              this.handleClose()
              // 刷新父页面
              this.$emit('handlePagination')
            })
          } else {
            // 新增标签
            saveTag(options).then(res => {
              if (res.code !== '2000') {
                this.$message.warning(res.explanation)
                return
              }
              // 关闭弹窗
              this.handleClose()
              // 刷新父页面
              this.$emit('handlePagination')
            })
          }
        }
      })
    },
    handleClose() {
      this.tagsForm = { color: '#409EFF' }
      this.isShowRoleDialog = false
      this.$refs.tagsForm.resetFields()
    }
  }
}
</script>
<style lang="scss">
   .crm-add-tag-dialog{
     .mg_t_10 {
        margin-top: 10px;
        position: relative;
     }
     .crm-color-name {
        position: absolute;
        margin-left: 10px;
        font-size: 14px;
     }
     .el-radio.is-checked .el-radio__inner:after{
        transform: rotate(45deg) scaleY(1) !important;
        box-sizing: content-box !important;
        content: "";
        border: 1px solid #fff !important;
        border-left: 0 !important;
        border-top: 0 !important;
        height: 7px !important;
        left: 10px!important;
        position: absolute !important;
        top: 8px !important;
        width: 7px !important;
        transition: transform .15s ease-in .05s;
        transform-origin: center !important;
        background-color: transparent !important;
        border-radius: inherit !important;
     }
     .el-radio__label{
       display: none;
     }
     .el-radio__input{
       margin-right: 10px;
     }
     .el-radio__input .el-radio__inner{
        display: inline-block;
        position: relative;
        border: 1px solid #dcdfe6;
        border-radius: 2px;
        box-sizing: border-box;
        width: 30px;
        height: 30px;
        border: none;
     }
     .blue .el-radio__input .el-radio__inner{
       background-color: #2db7f5;
     }
     .green .el-radio__input .el-radio__inner{
       background-color: #67c23a;
     }
     .pink .el-radio__input .el-radio__inner{
       background-color: #f56c6c;
     }
     .yellow .el-radio__input .el-radio__inner{
       background-color: #ffa902;
     }
     .skyblue .el-radio__input .el-radio__inner{
       background-color: #00cccd;
     }
     .lime .el-radio__input .el-radio__inner{
       background-color: #aace06;
     }
     .hotpink .el-radio__input .el-radio__inner{
       background-color: #e03e74;
     }
    .el-dialog__body{
        padding-bottom: 0;
      }
      .el-dialog__footer{
        text-align: center;
        padding-bottom: 30px;
      }
    .el-form{
      margin: 0px 39px;
      .el-form-item{
          margin-bottom: 25px;
      }
    }
  }
</style>
